
import { Component, Prop, Vue } from 'vue-property-decorator'
import { CreateElement, VNode } from 'vue'
import { TypeformForm } from '@/api/model/typeform/typeform-form'
import { TypeformReferenceRegExp } from '@/api/model/typeform/typeform-form'

@Component
export default class HighlightReferences extends Vue {
    @Prop({ required: true }) readonly form!: TypeformForm
    @Prop({ required: true }) readonly content: string

    render(createElement: CreateElement): VNode {
        const children = []

        const contentParts = this.content.split(TypeformReferenceRegExp)
        while (contentParts.length) {
            const contentPart = contentParts.shift()
            if (contentPart.match(TypeformReferenceRegExp)) {
                const referenceType = contentParts.shift()
                const reference = contentParts.shift()

                let label = reference
                if (referenceType === 'field') {
                    const field = this.form.fields.find(f => f.ref === reference)
                    if (field) {
                        label = field.title.replaceAll(TypeformReferenceRegExp, '_')
                    }
                }

                children.push(createElement(
                    'span',
                    {
                        class: 'inline-block px-1 bg-green-100 border border-dashed border-green-200 font-normal font-regular text-sm text-green-600',
                    },
                    label,
                ))
            } else {
                children.push(contentPart)
            }
        }

        return createElement(
            'span',
            {},
            children,
        )
    }
}
